"use client";

import type { ReactNode } from "react";
import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";

interface SectionShellProps {
  children: ReactNode;
  className?: string;
}

/**
 * Wrapper every feature section renders through. Sections are keyed on the
 * active id, so mounting one is what plays its entrance — this shell owns the
 * shared fade-up and each section adds whatever motion is its own.
 */
export function SectionShell({ children, className = "" }: SectionShellProps) {
  const rootRef = useRef<HTMLDivElement>(null);

  useGSAP(
    () => {
      gsap.from(rootRef.current, {
        opacity: 0,
        y: 24,
        duration: 0.6,
        ease: "power3.out",
      });
    },
    { scope: rootRef },
  );

  return (
    <div ref={rootRef} className={`menu-section ${className}`}>
      {children}
    </div>
  );
}
